import React, { useRef } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Spin } from 'antd';

import NavigationSideMenu from '../containers/navigation/NavigationSideMenu';
import FunnelsView from '../containers/funnel/FunnelsView';
import SegmentsView from '../containers/segment/SegmentsView';
import Retention from '../containers/retention/Retention';
import RetentionComplex from '../containers/retention/RetentionComplex';
import FieldPathsView from '../containers/FieldPathsView';
import MappingManualView from '../containers/mapping/manual/View';
import AuthorizationView from '../containers/authorization/AuthorizationView';
import UsageView from '../containers/usage/UsageView';
import RevenueView from '../containers/revenue/RevenueView';
import LabelsView from '../containers/labels/LabelsView';
import EventsView from '../containers/event/EventsView';
import { LOCATION } from '../constants/location';
import Users from '../containers/users/Users';
import DashboardCards from '../containers/dashboards/cards/DashboardsCards';
import BlankMain from './BlankMain';
import CheckedRoute from '../containers/CheckedRoute';
import { TABS } from '../constants/navigation';
import ErrorBoundary from './ErrorBoundary';
import SimpleNavigationBar from './navigation/SimpleNavigationBar';

const Main = () => {
  const scrollRef = useRef();

  return (
    <div style={{ display: 'flex', alignItems: 'stretch', height: '100%' }}>
      <div style={{ flexShrink: 0 }}>
        <NavigationSideMenu />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflowX: 'hidden' }}>
        <div ref={scrollRef} style={{ flex: 1, overflowY: 'auto' }}>
          <Routes>
            <Route path="/" element={<SimpleNavigationBar />} />

            <Route
              path={LOCATION.DASHBOARDS}
              element={
                <CheckedRoute
                  permissions={TABS.DASHBOARDS.permission}
                  events={TABS.DASHBOARDS.events}
                >
                  <DashboardCards />
                </CheckedRoute>
              }
            />

            <Route
              path={`${LOCATION.SEGMENTS}/*`}
              element={
                <CheckedRoute permissions={TABS.SEGMENTS.permission} events={TABS.SEGMENTS.events}>
                  <SegmentsView />
                </CheckedRoute>
              }
            />

            <Route
              path={`${LOCATION.FUNNELS}/*`}
              element={
                <CheckedRoute permissions={TABS.FUNNELS.permission} events={TABS.FUNNELS.events}>
                  <FunnelsView />
                </CheckedRoute>
              }
            />

            <Route
              path={LOCATION.RETENTION}
              element={
                <CheckedRoute
                  permissions={TABS.RETENTION.permission}
                  events={TABS.RETENTION.events}
                >
                  <Retention />
                </CheckedRoute>
              }
            />

            <Route
              path={LOCATION.EVENTS}
              element={
                <CheckedRoute permissions={TABS.EVENTS.permission} events={TABS.EVENTS.events}>
                  <EventsView />
                </CheckedRoute>
              }
            />

            <Route
              path={LOCATION.USAGE}
              element={
                <CheckedRoute permissions={TABS.USAGE.permission} events={TABS.USAGE.events}>
                  <UsageView />
                </CheckedRoute>
              }
            />

            <Route
              path={LOCATION.REVENUE}
              element={
                <CheckedRoute permissions={TABS.REVENUE.permission} events={TABS.REVENUE.events}>
                  <RevenueView />
                </CheckedRoute>
              }
            />

            <Route
              path={LOCATION.USERS}
              element={
                <CheckedRoute permissions={TABS.USERS.permission} events={TABS.USERS.events}>
                  <Users />
                </CheckedRoute>
              }
            />

            <Route
              path={LOCATION.LABELS}
              element={
                <CheckedRoute permissions={TABS.LABELS.permission} events={TABS.LABELS.events}>
                  <LabelsView />
                </CheckedRoute>
              }
            />

            <Route
              path={LOCATION.ADVANCED_MAPPING}
              element={
                <CheckedRoute
                  permissions={TABS.ADVANCED_MAPPING.permission}
                  events={TABS.ADVANCED_MAPPING.events}
                >
                  <MappingManualView />
                </CheckedRoute>
              }
            />

            <Route
              path={LOCATION.ADVANCED_RETENTION}
              element={
                <CheckedRoute
                  permissions={TABS.ADVANCED_RETENTION.permission}
                  events={TABS.ADVANCED_RETENTION.events}
                >
                  <RetentionComplex />
                </CheckedRoute>
              }
            />

            <Route
              path={LOCATION.FIELDS}
              element={
                <CheckedRoute permissions={TABS.FIELDS.permission} events={TABS.FIELDS.events}>
                  <FieldPathsView />
                </CheckedRoute>
              }
            />

            <Route
              path={LOCATION.AUTHORIZATION}
              element={
                <CheckedRoute
                  path={`${LOCATION.AUTHORIZATION}`}
                  permissions={TABS.AUTHORIZATION.permission}
                  events={TABS.AUTHORIZATION.events}
                >
                  <AuthorizationView />
                </CheckedRoute>
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
};

const Loading = () => (
  <Spin spinning size="large">
    <BlankMain />
  </Spin>
);

export default ({ applicationReady }) => (
  <ErrorBoundary>{applicationReady ? <Main /> : <Loading />}</ErrorBoundary>
);
